import React, { memo, ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { ContactInteractionInstagram } from '@lgg/isomorphic/types/__generated__/graphql';
import { matchContactInteractionInstagramExhaustive } from '@lgg/isomorphic/utils/match-contact-interaction';
import { TextItem } from 'src/components/pages/conversations/components/contact-interactions/items/text-item';

type InstagramItemProps = {
  contactInteraction: ContactInteractionInstagram;
  conversationId: string;
};

export const InstagramItem = memo<InstagramItemProps>(
  ({ contactInteraction, conversationId }) => {
    const buildManualInteractionTitle = (): ReactElement => {
      const transComponents = { strong: <strong /> };

      return matchContactInteractionInstagramExhaustive(contactInteraction, {
        inboundWithParticipatingEntity: ({ participatingEntity }) => (
          <Trans
            i18nKey="conversations:contactInteractionBubble.instagram.inboundWithParticipatingEntity"
            components={transComponents}
            values={{ participatingEntityLabel: participatingEntity.label }}
          />
        ),
        inboundWithoutParticipatingEntity: () => (
          <Trans
            i18nKey="conversations:contactInteractionBubble.instagram.inboundWithoutParticipatingEntity"
            components={transComponents}
          />
        ),
        outbound: () => (
          <Trans
            i18nKey="conversations:contactInteractionBubble.instagram.outbound"
            components={transComponents}
          />
        ),
      });
    };

    return (
      <TextItem
        conversationId={conversationId}
        testId="contact-interaction-instagram"
        contactInteraction={contactInteraction}
        titleBuilder={buildManualInteractionTitle}
      />
    );
  },
);
